import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { UseFormReturn, useWatch } from "react-hook-form";

import posInventoryCore from "../../core/inventory.core";
import { loadProducts } from "../../core/product.core";
import { ProductListFilter } from "../../types/product";
import useGetRetailShopId from "../useGetRetailShopId.hook";
import { getSinglePos } from "../../core/retailShop.core";

export default function useProductQuery(methods: UseFormReturn<ProductListFilter, any>) {
  const { query } = useRouter();

  const retailShopId = useGetRetailShopId();

  const { data: retailShop } = useQuery({
    enabled: !!retailShopId,
    queryFn: () => getSinglePos(retailShopId!),
    queryKey: ["retailShopId", retailShopId],
  });

  const [pageSize, search, page] = useWatch({
    control: methods.control,
    name: ["pageSize", "search", "page"],
  });

  return useQuery({
    enabled: !!retailShop,
    queryFn: async (context) => {
      const data = await loadProducts({
        catSlug: context.queryKey[4] as string,
        paging: {
          page: context.queryKey[1] as number,
          size: context.queryKey[2] as number,
        },
        search: context.queryKey[3] as string,
      });

      const newProductList = await posInventoryCore.loadProductInventories(data.list, retailShop?.warehouseIds ?? []);

      return {
        list: newProductList,
        size: data.size,
      };
    },

    queryKey: ["products", Number(query.page) || 1, pageSize, search ?? query.search, query.slug],
  });
}
